import { Integration } from "../../../types"

export function timestampToDate(created: string): Date {
  return new Date(parseInt(created, 10) * 1000)
}

export function formatDateHeader(created: string): string {
  const date = timestampToDate(created)
  if (date.toDateString() === new Date().toDateString()) return "TODAY"
  return date
    .toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric"
    })
    .toUpperCase()
}

export function groupByDate(
  integrations: Integration[]
): { label: string; items: Integration[] }[] {
  const groups: Map<string, Integration[]> = new Map()

  for (const integration of integrations) {
    const dateKey = integration.created
      ? timestampToDate(integration.created).toDateString()
      : "Unknown"
    const items = groups.get(dateKey) ?? []
    items.push(integration)
    groups.set(dateKey, items)
  }

  return Array.from(groups.entries()).map(([, items]) => ({
    label: items[0].created
      ? formatDateHeader(items[0].created)
      : "UNKNOWN DATE",
    items
  }))
}

export const DateSectionHeader = ({ label }: { label: string }) => (
  <div className="flex items-center gap-3 mb-2 mt-4">
    <span className="text-xs font-semibold uppercase tracking-widest text-[#757575] whitespace-nowrap">
      {label}
    </span>
    <div className="flex-1 h-px bg-[#e4e4e4]" />
  </div>
)
